
import { motion} from 'framer-motion';
import {  useState } from 'react';

export default function ContactSection() {
  
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    phone: '',
    service: '',
    message: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const submitAddr = "https://readdy.ai/api/form/d3jqdrnb6m158lvbn9kg";

 

  const contactInfo = [
    {
      icon: 'ri-phone-line',
      title: 'Call Us',
      details: ['+961 79 124 624'],
      color: 'text-[#d02b37]',
    },
    {
      icon: 'ri-mail-line',
      title: 'Email Us',
      details: ['info@primeedge-lb.com'],
      color: 'text-[#225a96]',
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Visit Us',
      details: ['Address: Saeb Salam street', 'Beirut','Lebanon'],
      color: 'text-[#1a4670]',
    },
    // {
    //   icon: 'ri-time-line',
    //   title: 'Business Hours',
    //   details: ['Mon - Fri: 9:00 AM - 6:00 PM', 'Sat: 10:00 AM - 4:00 PM'],
    //   color: 'text-[#1a4670]',
    // },
  ];

  const handleInputChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e: React.FormEvent) => {
  
    e.preventDefault();
    const phoneNumber = "96179124624"; 
  
    const message = `Hello, I'm ${formData.name}.
    Email: ${formData.email}
    Company: ${formData.company || 'N/A'}
    Phone: ${formData.phone || 'N/A'}
    Service Interested In: ${formData.service || 'N/A'}
    Project Details: ${formData.message}`;

    // Encode the message for the URL
    const encodedMessage = encodeURIComponent(message);

    // WhatsApp URL
    const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;

    // Open WhatsApp in new tab (or same tab if you prefer)
    window.open(whatsappURL, "_blank");

  // Optional: Reset form after opening WhatsApp
  setFormData({
    name: '',
    email: '',
    company: '',
    phone: '',
    service: '',
    message: '',
  });
};


  return (
    <section
      id="contact"
      className="relative py-20 overflow-hidden bg-gradient-to-br from-[#f5f5f5] via-[#ffffff] to-[#e5e5e5]"
    >
      {/* Background Elements */}
      <div className="absolute inset-0">
        <div className="absolute top-20 right-20 w-80 h-80 bg-gradient-to-br from-[#225a96]/10 to-[#d02b37]/5 rounded-full blur-3xl" />
        <div className="absolute bottom-20 left-20 w-64 h-64 bg-gradient-to-tr from-[#d02b37]/8 to-[#225a96]/10 rounded-full blur-2xl" />
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-gradient-radial from-[#225a96]/5 via-transparent to-transparent rounded-full" />
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.2 }}
          viewport={{once:true}}
          className="text-center mb-16"
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, delay: 0.3 }}
            viewport={{once:true}}
            className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-[#225a96]/10 to-[#d02b37]/10 rounded-full mb-6 backdrop-blur-sm border border-[#225a96]/20"
          >
            <i className="ri-mail-send-line text-lg text-[#d02b37] mr-2" />
            <span className="text-[#225a96] font-semibold text-sm tracking-wider uppercase" style={{ fontFamily: 'system-ui, -apple-system, sans-serif' }}>
              Get In Touch
            </span>
          </motion.div>
          
          <motion.h2
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.4 }}
            viewport={{once:true}}
            className="text-3xl md:text-5xl font-bold text-[#225a96] mb-6 leading-tight"
            style={{ fontFamily: 'system-ui, -apple-system, sans-serif' }}
          >
            Start Your Project
            <span className="block bg-gradient-to-r from-[#d02b37] to-[#ff6b7a] bg-clip-text text-transparent">
              Today
            </span>
          </motion.h2>
          
          <motion.p
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.6 }}
            viewport={{once:true}}
            className="text-base md:text-lg text-[#1a4670] max-w-3xl mx-auto leading-relaxed"
            style={{ fontFamily: 'system-ui, -apple-system, sans-serif' }}
          >
            Ready to transform your workspace? Let's discuss your vision and create an environment 
            that inspires success and productivity.
          </motion.p>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-12">
          {/* Contact Form */}
          <motion.div
            initial={{ opacity: 0, x: -60 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 1, delay: 0.8 }}
            viewport={{once:true}}
            className="bg-white/80 backdrop-blur-sm border border-[#e5e5e5] hover:border-[#225a96]/30 rounded-2xl p-8 transition-all duration-500"
          >
            <h3 className="text-xl md:text-2xl font-bold text-[#225a96] mb-6" style={{ fontFamily: 'system-ui, -apple-system, sans-serif' }}>
              Send Us a Message
            </h3>
            <form
              data-readdy-form
              id="contact-form"
              action={submitAddr}
              method="POST"
              className="space-y-6"
              onSubmit={handleSubmit}
            >
              <div className="grid md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-[#1a4670] text-sm font-medium mb-2" style={{ fontFamily: 'system-ui, -apple-system, sans-serif' }}>
                    Full Name *
                  </label>
                  <input
                    type="text"
                    name="name"
                    required
                    value={formData.name}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 bg-white border border-[#e5e5e5] rounded-lg text-[#1a4670] placeholder-gray-400 focus:outline-none focus:border-[#d02b37] focus:ring-2 focus:ring-[#d02b37]/20 transition-all duration-300 text-sm"
                    placeholder="Enter your full name"
                    style={{ fontFamily: 'system-ui, -apple-system, sans-serif' }}
                  />
                </div>
                <div>
                  <label className="block text-[#1a4670] text-sm font-medium mb-2" style={{ fontFamily: 'system-ui, -apple-system, sans-serif' }}>
                    Email Address *
                  </label>
                  <input
                    type="email"
                    name="email"
                    required
                    value={formData.email}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 bg-white border border-[#e5e5e5] rounded-lg text-[#1a4670] placeholder-gray-400 focus:outline-none focus:border-[#d02b37] focus:ring-2 focus:ring-[#d02b37]/20 transition-all duration-300 text-sm"
                    placeholder="Enter your email"
                    style={{ fontFamily: 'system-ui, -apple-system, sans-serif' }}
                  />
                </div>
              </div>

              <div className="grid md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-[#1a4670] text-sm font-medium mb-2" style={{ fontFamily: 'system-ui, -apple-system, sans-serif' }}>
                    Company Name
                  </label>
                  <input
                    type="text"
                    name="company"
                    value={formData.company}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 bg-white border border-[#e5e5e5] rounded-lg text-[#1a4670] placeholder-gray-400 focus:outline-none focus:border-[#d02b37] focus:ring-2 focus:ring-[#d02b37]/20 transition-all duration-300 text-sm"
                    placeholder="Enter company name"
                    style={{ fontFamily: 'system-ui, -apple-system, sans-serif' }}
                  />
                </div>
                <div>
                  <label className="block text-[#1a4670] text-sm font-medium mb-2" style={{ fontFamily: 'system-ui, -apple-system, sans-serif' }}>
                    Phone Number
                  </label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 bg-white border border-[#e5e5e5] rounded-lg text-[#1a4670] placeholder-gray-400 focus:outline-none focus:border-[#d02b37] focus:ring-2 focus:ring-[#d02b37]/20 transition-all duration-300 text-sm"
                    placeholder="Enter phone number"
                    style={{ fontFamily: 'system-ui, -apple-system, sans-serif' }}
                  />
                </div>
              </div>

              <div>
                <label className="block text-[#1a4670] text-sm font-medium mb-2" style={{ fontFamily: 'system-ui, -apple-system, sans-serif' }}>
                  Service Interested In
                </label>
                <div className="relative">
                  <select
                    name="service"
                    value={formData.service}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 bg-white border border-[#e5e5e5] rounded-lg text-[#1a4670] focus:outline-none focus:border-[#d02b37] focus:ring-2 focus:ring-[#d02b37]/20 transition-all duration-300 text-sm pr-8 appearance-none"
                    style={{ fontFamily: 'system-ui, -apple-system, sans-serif' }}
                  >
                    <option value="">Select a service</option>
                    <option value="Design & Consultancies">Design & Consultancies</option>
                    <option value="Premium Materials Supply">Premium Materials Supply</option>
                    <option value="Turnkey Fit-out Execution">Turnkey Fit-out Execution</option>
                    <option value="Wall Panels & Partitions">Wall Panels & Partitions</option>
                    <option value="Artistic Metal Accents">Artistic Metal Accents</option>
                    <option value="Custom Metal Furniture">Custom Metal Furniture</option>
                    <option value="Custom Railings">Custom Railings</option>
                    <option value="Gates & Entrances">Gates & Entrances</option>
                    <option value="Fences & Boundaries">Fences & Boundaries</option>
                  </select>
                  <i className="ri-arrow-down-s-line absolute right-3 top-1/2 transform -translate-y-1/2 text-[#1a4670] pointer-events-none"></i>
                </div>
              </div>

              <div>
                <label className="block text-[#1a4670] text-sm font-medium mb-2" style={{ fontFamily: 'system-ui, -apple-system, sans-serif' }}>
                  Project Details *
                </label>
                <textarea
                  name="message"
                  required
                  rows={4}
                  maxLength={500}
                  value={formData.message}
                  onChange={handleInputChange}
                  className="w-full px-4 py-3 bg-white border border-[#e5e5e5] rounded-lg text-[#1a4670] placeholder-gray-400 focus:outline-none focus:border-[#d02b37] focus:ring-2 focus:ring-[#d02b37]/20 transition-all duration-300 text-sm resize-none"
                  placeholder="Tell us about your project requirements, timeline, and budget..."
                  style={{ fontFamily: 'system-ui, -apple-system, sans-serif' }}
                />
                <div className="text-right text-xs text-[#1a4670]/60 mt-2" style={{ fontFamily: 'system-ui, -apple-system, sans-serif' }}>
                  {formData.message.length}/500 characters
                </div>
              </div>

              <motion.button
                type="submit"
                disabled={isSubmitting}
                whileHover={{ 
                  scale: 1.02,
                  boxShadow: "0 25px 50px rgba(208, 43, 55, 0.4), 0 0 40px rgba(208, 43, 55, 0.3)",
                }}
                whileTap={{ scale: 0.98 }}
                className="w-full relative overflow-hidden bg-gradient-to-r from-[#d02b37] to-[#ff6b7a] hover:from-[#ff6b7a] hover:to-[#d02b37] text-white py-4 rounded-2xl font-bold transition-all duration-700 flex items-center justify-center space-x-3 shadow-2xl whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed text-base"
                style={{ fontFamily: 'system-ui, -apple-system, sans-serif' }}
              >
                <motion.div
                  className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full hover:translate-x-full transition-transform duration-700"
                />
                {isSubmitting ? (
                  <>
                    <i className="ri-loader-4-line animate-spin text-lg relative z-10"></i>
                    <span className="relative z-10">Sending...</span>
                  </>
                ) : (
                  <>
                    <i className="ri-send-plane-line text-lg relative z-10"></i>
                    <span className="relative z-10">Send Message</span>
                  </>
                )}
              </motion.button>

              {/* Success/Error Messages */}
              {submitStatus === 'success' && (
                <div className="bg-green-100 border border-green-300 rounded-lg p-4 text-green-700 text-center text-sm" style={{ fontFamily: 'system-ui, -apple-system, sans-serif' }}>
                  <i className="ri-check-line mr-2"></i>
                  Message sent successfully! We'll get back to you soon.
                </div>
              )}
              {submitStatus === 'error' && (
                <div className="bg-red-100 border border-red-300 rounded-lg p-4 text-red-700 text-center text-sm" style={{ fontFamily: 'system-ui, -apple-system, sans-serif' }}>
                  <i className="ri-error-warning-line mr-2"></i>
                  Failed to send message. Please try again.
                </div>
              )}
            </form>
          </motion.div>

          {/* Contact Info */}
          <motion.div
            initial={{ opacity: 0, x: 60 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 1, delay: 1 }}
            viewport={{once:true}}
            className="space-y-6"
          >
            {/* Contact Cards */}
            <div className="grid gap-4">
              {contactInfo.map((info, index) => (
                <motion.div
                  key={info.title}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: 1.2 + index * 0.1 }}
                  whileHover={{ 
                    scale: 1.02,
                    backgroundColor: "rgba(34, 90, 150, 0.05)",
                    boxShadow: "0 20px 40px rgba(34, 90, 150, 0.15)",
                  }}
                  viewport={{once:true}}
                  className="bg-white/80 backdrop-blur-sm border border-[#e5e5e5] hover:border-[#225a96]/30 rounded-2xl p-6 transition-all duration-500 group cursor-pointer"
                >
                  <div className="flex items-start gap-4">
                    <motion.div 
                      className="w-12 h-12 bg-gradient-to-br from-[#d02b37] to-[#ff6b7a] rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300"
                      whileHover={{ rotate: 20 }}
                      transition={{ duration: 0.6 }}
                    >
                      <i className={`${info.icon} text-white text-lg`}></i>
                    </motion.div>
                    <div>
                      <h4 className="text-[#225a96] font-bold text-base mb-2 group-hover:text-[#d02b37] transition-colors duration-300" style={{ fontFamily: 'system-ui, -apple-system, sans-serif' }}>
                        {info.title}
                      </h4>
                      {info.details.map((detail, idx) => (
                        <p key={idx} className="text-[#1a4670] mb-1 text-sm group-hover:text-[#225a96] transition-colors duration-300" style={{ fontFamily: 'system-ui, -apple-system, sans-serif' }}>
                          {detail}
                        </p>
                      ))}
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>

            {/* Map */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 1.6 }}
              viewport={{once:true}}
              className="bg-white/80 backdrop-blur-sm border border-[#e5e5e5] hover:border-[#225a96]/30 rounded-2xl overflow-hidden transition-all duration-500"
            >
              <div className="p-6 border-b border-[#e5e5e5]">
                <h4 className="text-[#225a96] font-bold text-base flex items-center gap-3" style={{ fontFamily: 'system-ui, -apple-system, sans-serif' }}>
                  <i className="ri-map-pin-line text-[#d02b37] text-lg"></i>
                  Our Location
                </h4>
              </div>
              <div className="h-48">
                 <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3347.7080523270547!2d35.4848216!3d33.8818771!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzPCsDUyJzU0LjgiTiAzNcKwMjknMTQuNiJF!5e0!3m2!1sen!2sae!4v1739432400000!5m2!1sen!2sae"
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Location Coordinates - Lebanon"
                />
              </div>
            </motion.div>

            {/* Action Buttons */}
            {/* <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 1.8 }}
              className="grid grid-cols-2 gap-4"
            >
              <motion.button
                whileHover={{ 
                  scale: 1.05,
                  boxShadow: "0 20px 40px rgba(208, 43, 55, 0.3)",
                }}
                whileTap={{ scale: 0.95 }}
                className="bg-gradient-to-r from-[#d02b37] to-[#ff6b7a] hover:from-[#ff6b7a] hover:to-[#d02b37] text-white py-3 rounded-xl font-semibold transition-all duration-500 flex items-center justify-center gap-2 text-sm shadow-lg whitespace-nowrap"
                style={{ fontFamily: 'system-ui, -apple-system, sans-serif' }}
              >
                <i className="ri-phone-line"></i>
                Call Now
              </motion.button>
              <motion.button
                whileHover={{ 
                  scale: 1.05,
                  backgroundColor: "rgba(34, 90, 150, 0.1)",
                  boxShadow: "0 20px 40px rgba(34, 90, 150, 0.2)",
                }}
                whileTap={{ scale: 0.95 }}
                className="border-2 border-[#225a96] text-[#225a96] hover:bg-[#225a96] hover:text-white py-3 rounded-xl font-semibold transition-all duration-500 flex items-center justify-center gap-2 text-sm whitespace-nowrap"
                style={{ fontFamily: 'system-ui, -apple-system, sans-serif' }}
              >
                <i className="ri-calendar-line"></i>
                Schedule Visit
              </motion.button>
            </motion.div> */}
          </motion.div>
        </div>
      </div>
    </section>
  );
}
